import {API} from 'aws-amplify';

export const read = async () => API.get('robinhoodEngUserApi', '/animals', {});

export const readOne = async (id, limit = 20, startKey = null) => API.get('robinhoodEngUserApi',
  `/animals/${id}?limit=${limit}${startKey !== null ? `&startKey=${startKey}` : ''}`, {});
